import { useState, useEffect, useCallback } from 'react';
import { isDesktop } from '../utils/desktop';

const STORAGE_KEY = 'app:theme';
const DEFAULT_THEME = 'modern'; // 'modern' | 'classic'

// A versão desktop roda só no tema moderno: o classic.css é desenhado para o
// navegador e a janela nativa não deve expor o alternador.
const themeLocked = () => isDesktop();

const readStored = () => {
  if (themeLocked()) return 'modern';
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'classic' || v === 'modern' ? v : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
};

const applyToRoot = (theme) => {
  const root = document.documentElement;
  root.classList.remove('theme-modern', 'theme-classic');
  root.classList.add(`theme-${theme}`);
  root.setAttribute('data-theme', theme);
};

export const useTheme = () => {
  const [theme, setTheme] = useState(readStored);

  useEffect(() => {
    applyToRoot(theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
  }, [theme]);

  const toggleTheme = useCallback(() => {
    if (themeLocked()) return;
    setTheme((t) => (t === 'classic' ? 'modern' : 'classic'));
  }, []);

  return {
    theme,
    setTheme,
    toggleTheme,
    isClassic: theme === 'classic',
    // quem renderiza o alternador usa isto para escondê-lo no desktop
    canToggleTheme: !themeLocked(),
  };
};

// Apply theme immediately on module load to prevent FOUC
applyToRoot(readStored());
